import Ajustes from './pages/Ajustes';
import Casos from './pages/Casos';
import Categorias from './pages/Categorias';
import ConfiguracionCorreo from './pages/ConfiguracionCorreo';
import Dashboard from './pages/Dashboard';
import Discord from './pages/Discord';
import EntornoPruebas from './pages/EntornoPruebas';
import Home from './pages/Home';
import Lead from './pages/Lead';
import Login from './pages/Login';
import PresupuestoLibre from './pages/PresupuestoLibre';
import Productos from './pages/Productos';
import Roadmap from './pages/Roadmap';
import Metrics from './pages/Metrics';
import Webhooks from './pages/Webhooks';
import Usuarios from './pages/Usuarios';
import CEODashboard from './pages/CEODashboard';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Ajustes": Ajustes,
    "Casos": Casos,
    "Categorias": Categorias,
    "ConfiguracionCorreo": ConfiguracionCorreo,
    "Dashboard": Dashboard,
    "Discord": Discord,
    "EntornoPruebas": EntornoPruebas,
    "Home": Home,
    "Lead": Lead,
    "Login": Login,
    "Metrics": Metrics,
    "PresupuestoLibre": PresupuestoLibre,
    "Productos": Productos,
    "Roadmap": Roadmap,
    "Webhooks": Webhooks,
    "Usuarios": Usuarios,
    "CEODashboard": CEODashboard,
}

export const pagesConfig = {
    mainPage: "Dashboard",
    Pages: PAGES,
    Layout: __Layout,
};